module.exports = __webpack_public_path__ + "img/reservas.db17f23e.svg";